export const FEEDBACK_MAIL_TO = 'support@iqx.no';
export const FEEDBACK_MAIL_SUBJECT = '';
export const FEEDBACK_MAIL_BODY = '';
